import React from 'react';
import { renderImage } from './shared/renderers';

export default function ImageBlock({ props = {}, theme }) {
  return renderImage(props, theme);
}
